import React, { useContext, useLayoutEffect, useState } from 'react';

import * as S from './styles';
import ScreensStaticContext from 'context/ScreensStaticContext';
import { ScreenBlackFridayType } from 'types/ScreenBlackFridayType';
import Carousel from 'components/Carousel';
import { CarouselImagesProps } from 'types/CarouselImagesProps';
import CounterBlackFriday from 'components/CounterBlackFriday';
import CarrosselProductsScreenStatics from 'components/CarrosselProductsScreenStatics';
import ListProductsBlackFriday from 'components/ListProductsBlackFriday';

export default function BodyBlackFriday() {
	const { screens } = useContext(ScreensStaticContext);
	const [blackFriday, setBlackFriday] = useState<ScreenBlackFridayType | null>(
		null
	);

	function handleWithImgs(): CarouselImagesProps[] {
		const imgs: CarouselImagesProps[] = [];

		if (blackFriday) {
			blackFriday.carrouselImgs.forEach((item) => {
				imgs.push({ id: item.id, imageUrl: item.urlImage });
			});
		}

		return imgs;
	}

	useLayoutEffect(() => {
		if (screens.length > 0) {
			const screen = screens.find((screen) => screen.type === 'blackFriday');
			if (screen) {
				setBlackFriday((screen.data as ScreenBlackFridayType) || null);
			}
		}
	}, [screens]);

	return blackFriday ? (
		<S.container>
			<Carousel items={handleWithImgs()} showClicks={false} isBtns={false} />
			<S.box>
				<CounterBlackFriday
					endDate={blackFriday.firstTimer.endDate}
					title={blackFriday.firstTimer.title}
				/>
			</S.box>

			<S.box>
				<CarrosselProductsScreenStatics
					query={blackFriday.firstQueryListProductsBlackFriday}
					colorBackGroud="#522573"
				/>
			</S.box>

			<S.box>
				<ListProductsBlackFriday {...blackFriday.carrosselProducts} />
			</S.box>

			<S.bigImg>
				<img src={blackFriday.firstBigImg.urlImage} />
			</S.bigImg>

			<S.box>
				<CounterBlackFriday
					endDate={blackFriday.secondTimer.endDate}
					title={blackFriday.secondTimer.title}
				/>
			</S.box>

			<S.box>
				<CarrosselProductsScreenStatics
					query={blackFriday.secondQueryListProductsBlackFriday}
					colorBackGroud="#522573"
				/>
			</S.box>

			<S.video autoPlay={true} muted loop>
				<source src={blackFriday.videoUrl} type="video/mp4" />
				Seu navegador não suporta o elemento de vídeo.
			</S.video>

			<S.carrosselWithTitle>
				<h1>{blackFriday.thirdQueryListProductsBlackFriday.title}</h1>
				<CarrosselProductsScreenStatics
					query={blackFriday.thirdQueryListProductsBlackFriday.query}
					colorBackGroud="#522573"
				/>
			</S.carrosselWithTitle>
		</S.container>
	) : (
		<></>
	);
}
